import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import { MatchHeight } from 'js-match-height';
import { createContext } from '../modules/_helpers'
import '../../styles/theme.scss';

// Only need to import these once
import 'unfetch/polyfill';
import 'es6-promise/auto';

import CC from "CookieConsent"

function loadModuleJs() {
  if(window.loaded === true) return;
  document.querySelectorAll('[data-module]').forEach(el => {
    const name = el.getAttribute('data-module')
    const moduleInit = require(`../modules/${name}`).default
    const context = createContext(el)
    
    new moduleInit({ el, context })
    
  })
  window.loaded = true
}

document.addEventListener('DOMContentLoaded', () => {
  loadModuleJs();
  const matchHeight = new MatchHeight('.template-collection .product-block__detail__title');
  const matchHeight2 = new MatchHeight('.product-block__detail__description');
  const consent = document.querySelector('.cookie-consent')
  cookieconsent.initialise({
    container: consent,
    type: 'info',
    position: 'bottom',
    palette:{
      popup: {background: "#000", color: "#FFF"},
      button: {background: "#EA6642", color: "#FFF"},
    },
    revokable: false,
    content: {
      header: 'Cookies used on the website!',
      message: 'We use cookies to improve your experience on our website. You can find out more about which cookies we use ',
      dismiss: 'Got it!',
      allow: 'Allow cookies',
      deny: 'Decline',
      link: 'here',
      href: '/pages/privacy',
      close: '&#x274c;',
      policy: 'Cookie Policy',
      target: '_blank',
    }
  });
});
